import AccountDetailLayout from "layout/account-detail-layout/AccountDetailLayout";
import Layout from "layout/layout";

import Tools from "pages/business-suite/Tools";

export default function Campaigns() {
  return (
    <AccountDetailLayout>
      <div className="min-h-[calc(100vh-120px)]">
        <Tools />
      </div>
    </AccountDetailLayout>
  );
}
